import { laravelAxios } from "@/utils/axios";

// 登录
export const login = (data: { username: string, password: string }) => laravelAxios.post(`/api/auth/login`, data, {});

// 获取用户信息
export const me = () => laravelAxios.post(`/api/auth/me`, {}, {});

// 获取用户列表
export const getUserList = (params: any) => laravelAxios.get(`/api/user/get_user_list`, { params });

// 保存用户
export const saveUser = (data: any) => laravelAxios.post(`/api/user/save_user`, data, { successMsg: "操作成功" });

// 删除用户
export const deleteUser = (params: any) => laravelAxios.delete(`/api/user/delete_user`, { data: params, successMsg: "删除成功" });

// 获取权益字列表
export const getRightsList = () => laravelAxios.get(`/api/rights/get_rights_list`, {});

// 重置邀请码
export const resetUserInviteCode = (data: any) => laravelAxios.post(`/api/user/reset_user_invite_code`, data, { successMsg: "操作成功" });

// 获取用户详情
export const getUserDetail = (params: any) => laravelAxios.get(`/api/user/get_user_detail`, { params });

// 获取邀请列表
export const getInviteRelationsList = (params: any) => laravelAxios.get(`/api/invite_relations/get_invite_relations_list`, { params });

// 获取佣金记录列表
export const getCommissionRecordsList = (params: any) => laravelAxios.get(`/api/commission_records/get_commission_records_list`, { params });
